export const downloadAsCSV = (
  filename: string,
  headers: string[],
  rows: (string | number)[][]
) => {
  const csvContent = [
    headers.join(","),
    ...rows.map((row) =>
      row
        .map((cell) =>
          typeof cell === "string" ? `"${cell.replace(/"/g, '""')}"` : cell
        )
        .join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const parseCSV = <T = Record<string, string>>(csv: string): T[] => {
  // Helper function to parse a single row considering quotes
  const parseRow = (row: string): string[] => {
    const fields: string[] = [];
    let field = "";
    let inQuotes = false;

    for (let i = 0; i < row.length; i++) {
      const char = row[i];

      if (char === '"') {
        if (inQuotes && row[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = !inQuotes;
        }
      } else if (char === "," && !inQuotes) {
        fields.push(field);
        field = "";
      } else {
        field += char;
      }
    }
    fields.push(field);
    return fields;
  };

  const rows: string[] = [];
  let currentRow = "";
  let inQuotes = false;

  csv.split("\n").forEach((line) => {
    const quoteCount = (line.match(/"/g) || []).length;
    inQuotes = inQuotes ? !(quoteCount % 2) : !!(quoteCount % 2);

    currentRow += (currentRow ? "\n" : "") + line;

    if (!inQuotes) {
      rows.push(currentRow);
      currentRow = "";
    }
  });

  const rawHeaders = parseRow(rows[0]);
  const headers = rawHeaders.map((header) => {
    let normalized = header.replace(/^\uFEFF/, "").trim();
    if (normalized === "Folder") {
      normalized = "folderName";
    }
    return normalized;
  });

  const result = rows
    .slice(1)
    .filter((row) => row.trim())
    .map((row) => {
      const values = parseRow(row);
      const obj = {} as Record<string, string>;
      headers.forEach((header, index) => {
        if (header) {
          obj[header] = (values[index] || "").trim();
        }
      });
      return obj as T;
    });

  return result;
};
